import { render, staticRenderFns } from "./StudentQuestionsImgPositive.vue?vue&type=template&id=0d15500a&"
import script from "./StudentQuestionsImgPositive.vue?vue&type=script&lang=ts&"
export * from "./StudentQuestionsImgPositive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports